import React, { useEffect, useState } from "react";
import CommonInputField from "../components/BrandsPartnerComponents/common_input_field";
import CustomDropdown from "../components/BrandsPartnerComponents/dropdownfiled";
import { BrandsType } from "./dtos/brands.dtos";
import { GetCountries } from "../../API/endpoints/Common";
import { Form } from "antd";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";



type Props = {
  data: BrandsType;
  setData: React.Dispatch<React.SetStateAction<BrandsType>>;
  previousStep: () => void;
  isMobile?: boolean;
  nextStep: () => void;

};

const AboutYourBrandPage: React.FC<Props> = ({
  data,
  setData, nextStep, previousStep, isMobile
}) => {


  const [countries, setCountries] = useState<any[]>([]);

  const [form] = Form.useForm();
  const handleSubmit = (values: any) => {
    setData((prev) => ({ ...prev, ...values }));
    nextStep();
  };
  
  // Fetch country names
  useEffect(() => {
    (async () => {
      try {
        const response = await GetCountries();
        setCountries(
          response.data.map((item: any) => ({
            value: item.id,
            label: item.name,
          }))
        );
        const deduped = response.data.filter(
          (item: any, index: number, self: any[]) =>
            index === self.findIndex((t) => t.country_code === item.country_code)
        );

      } catch (error) { }
    })();
  }, []);
  useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Tell Us About Your Brand</div>
      <div className="common-sub-text pb-[60px]">We want to know your brand inside and out, so we can find the best opportunities for you. Drop in your details below!</div>

      {/* Grid Container */}
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSubmit}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-[16px] gap-y-[16px]">

          {/* Brand Name */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="company_name"
              rules={[{ required: true, message: "Organisation Name is required" }]}
            >  <CommonInputField
                label="Organisation Name"
                // placeholder="Brand Name"
                value={data.company_name}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    company_name: e.target.value,
                  }))
                }

              /></Form.Item>

          </div>

          {/* Country of Origin */}
          <div className="col-span-2 md:col-span-1">
          <Form.Item
              name="country_of_origin"
              rules={[
                { required: true, message: "Country of Origin is required" },
              ]}
            >
              <CustomDropdown
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    country_of_origin: e as number,
                  }))
                }
                options={countries}
                label="Country of Origin"
                value={
                  data.country_of_origin === 0 ? "" : data.country_of_origin
                }
              />
            </Form.Item>
          </div>

          {/* Company Name */}
          {/* <div className="col-span-2 md:col-span-1">
         

          <CommonInputField
            label="Company Name"
            // placeholder="Company Name"
            value={data.company_name}
            onChange={(e) =>
              setData((curret) => ({
                ...curret,
                company_name: e.target.value,
              }))
            }
            
        />

        </div> */}

          {/* Address Line 1 */}
          <div className="col-span-2 md:col-span-1.5">
            <Form.Item
              name="company_address_line1"
              rules={[{ required: true, message: "Address Line 1 is required" }]}
            ><CommonInputField
                label="Address Line 1"
                // placeholder="Address Line 1"
                value={data.company_address_line1}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    company_address_line1: e.target.value,
                  }))
                }

              /></Form.Item>
          </div>

          {/* Address Line 2 */}
          <div className="col-span-2 md:col-span-1.5">
            <CommonInputField
              label="Address Line 2"
              // placeholder="Address Line 2"
              value={data.company_address_line2}
              // onChange={(e)=>setaddressLine2Value(e.target.value)}
              onChange={(e) =>
                setData((curret) => ({
                  ...curret,
                  company_address_line2: e.target.value,
                }))
              }

            />

          </div>
          <div></div>

          {/* City/Town */}
          <div className="col-span-2 md:col-span-1">
            {/* <label className="block common-label pb-[6px]">City/Town</label> */}

            {/* <Select defaultValue="Singapore" className="w-full">
            <Option value="Singapore">Singapore</Option>
            <Option value="New York">New York</Option>
          </Select> */}
            <Form.Item
              name="city"
              rules={[{ required: true, message: "City/Town is required" }]}
            > <CommonInputField
                label="City/Town"
                placeholder=" "
                value={data.city}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    city: e.target.value,
                  }))
                }
              // onChange={(e)=>setaddressLine2Value(e.target.value)}

              /></Form.Item>
          </div>

          {/* State/Region */}
          <div className="col-span-2 md:col-span-1">
            {/* <label className="block common-label pb-[6px]">State/Region/Province</label>
          <Select defaultValue="Central Region" className="w-full">
            <Option value="Central Region">Central Region</Option>
            <Option value="North Region">North Region</Option>
          </Select> */}
            <Form.Item
              name="state"
              rules={[{ required: true, message: "State/Region/Province is required" }]}
            ><CommonInputField
                label="State/Region/Province"
                placeholder=" "
                value={data.state}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    state: e.target.value,
                  }))
                }

              /></Form.Item>
          </div>

          {/* Zip Code */}
          <div className="col-span-2 md:col-span-1">
            <Form.Item
              name="company_address_postal_code"
              rules={[{ required: true, message: "Zip Code/Post Code is required" }]}
            ><CommonInputField
                label="Zip Code/Post Code"
                // placeholder="238841"
                value={data.company_address_postal_code}
                type="number"
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    company_address_postal_code: e.target.value,
                  }))
                }

              /></Form.Item>

          </div>

          {/* Website Link */}
          <div className="col-span-2">
            <Form.Item
              name="website"
              rules={[{ required: true, message: "Website Link is required" },
                {
                  type: "url",
                  message: "Please enter a valid URL (e.g., https://example.com)",
                },
              ]}
            ><CommonInputField
                label="Website Link 🌐"
                // placeholder="https://www.example.com"
                value={data.website}
                // onChange={(e)=>setLinkValue(e.target.value)}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    website: e.target.value,
                  }))
                }

              /></Form.Item>
          </div>



        </div>
      </Form>
      {/* Desktop Next/Previous Navigation */}
      {!isMobile && (
        <div className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto">
          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
           onClick={() => form.submit()}
            label={"Next"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          }
          <NavigationButton
           onClick={() => form.submit()}
            label={"Next"}
            type="primary"
            block
          />
        </div>
      )}

    </div>
  );
};

export default AboutYourBrandPage;
